import { ChartOptionsProvider } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class HistoricEbitMarginOptionsProvider extends ChartOptionsProvider {
  getOptions(company) {
    if (!company.historic_ebitmargin_expectation || !company.historic_ebitmargin_year_three) {
      return;
    }
    const historicImpliedEbitMargin =  company.historic_ebitmargin_expectation.filter(item => (item.date && typeof item.value == 'number'));
    const historicYearThreeEbitMargin = company.historic_ebitmargin_year_three.filter(item => (item.date && typeof item.value == 'number'));
    const historicYearThreeRevenueGrowth = company.historic_year_three_revenue_growth ? company.historic_year_three_revenue_growth.filter(item => (item.date && typeof item.value == 'number')) : [];

    const ebitMarginExpectation = company.platformData.ebitMarginExpectation;
    const yearThree = company.platformData.ebitMarginData.yearThree;
    const yearThreeRevenueGrowth = company.platformData.companyAnalysis.yearThreeConsensusGrowth;
    const currentDate = new Date();
    currentDate.setHours(1,0,0,0);

    let chartOptions = {
      chart: Object.assign(this.defaultChartOptions.chart,{spacingBottom: 70}),
      title: 'Historic Implied EBIT Margin(%)',
      legend: this.defaultChartOptions.legend,
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          year: '%Y'
        }
      },
      yAxis: [{
        labels:{
            x:0
        },
        min: Math.min(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) - 2,
        max: Math.max(...historicImpliedEbitMargin.map(item => 100 * (parseFloat(item.value))),
          ...historicYearThreeEbitMargin.map(item => 100 * (parseFloat(item.value)))) + 2,
        minTickInterval: 1,
        title: {
          text:  null
        }
      },
      {
        labels:{
            x:0
        },
        min: Math.min(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) - 2,
        max: Math.max(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) + 2,
        minTickInterval: 1,
        title: {
          text:  null
        },
        opposite: true
      }
    ],
      tooltip: this.defaultChartOptions.tooltip,
      series: [
        {
          name: 'y3e EBIT Margin',
          yAxis: 0,
          data: [...historicYearThreeEbitMargin.map(item => [new Date(item.date).getTime(), 100 * parseFloat(item.value)]), [currentDate.getTime(), yearThree*100]],
          marker: {
            enabled: false
          },
          visible: true
        },
        , ,
        
        {
          name: 'Implied EBIT Margin',
          yAxis: 0,
          data: [...historicImpliedEbitMargin.map(item => [new Date(item.date).getTime(), 100 * parseFloat(item.value)]), [currentDate.getTime(), ebitMarginExpectation*100]],
          marker: {
            enabled: false
          },
          visible: true
        },
        {
          name: 'y3e Revenue Growth',
          yAxis: 1,
          data: [...historicYearThreeRevenueGrowth.map(item => [new Date(item.date).getTime(), 100 * parseFloat(item.value)]), [currentDate.getTime(), yearThreeRevenueGrowth*100]],
          marker: {
            enabled: false
          },
          visible: true
        },
      ],
    }
    chartOptions = this.setYMax(chartOptions);
    chartOptions = this.setYMin(chartOptions);
    return super.getOptions(company, chartOptions);
  };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/historic-ebit-margin.ts